import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PplLinkInvertedDirective } from './link-inverted.directive';
import { PplLinkDirective } from './link.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PplLinkDirective,
    PplLinkInvertedDirective
  ],
  exports: [
    PplLinkDirective,
    PplLinkInvertedDirective
  ]
})
export class PplLinkModule {
}

export * from './link.directive';

